import {Component, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApplicationService } from 'app/services/application.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PermitService } from 'app/services/permit.service';
import { VehicleService } from 'app/services/vehicle.service';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, merge } from 'rxjs/operators';
import { PlaceService } from 'app/services/place.service';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { DocumenttypeService } from 'app/services/documenttype.service';
import { RouteService } from 'app/services/route.service';
import { CountryService } from 'app/services/country.service';
import { PopupService } from 'app/services/shared/popup.service';
import { TimetableService } from 'app/services/timetable.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { environment } from '../../../../environments/environment';
import { DatePipe } from '@angular/common';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import * as angular from 'angular';
import { resolve } from 'url';
import  html2canvas from 'html2canvas';
import {AuthWebService} from '../../../services/authweb.service';

declare var $: any;

@Component({
  selector: 'app-timetable',
  templateUrl: './timetable.component.html',
  styleUrls: ['./timetable.component.css'],
  providers: [RouteService]
})
export class TimetableComponent implements OnInit {
  @Input() dataCntrl: any;
  @Input() isApproval: boolean = false;
  
  isLoading = false;
  message = "Loading timetables. Please wait...";
  instructMsg = '';
  departuresList: any = [];
  departuresListRemove: any = [];
  editFlag: boolean = false;
  pageload: boolean = false;
  showBlock: boolean = false;
  isDuplicateMode: boolean = false;
  isProcess:boolean=true;
  timetableDirection: any = "";  
  timeTableTemplate : any;
  timeTableDetail : any;

  permitStatus13: any;
  isExternalRole: boolean = true;
  constructor(private formBuilder: FormBuilder, private toastr: ToastrService,
    private showModal: PopupService, public applicationService: ApplicationService,
    private utility: UtilityServiceService,
    private router: Router, private permitService: PermitService,private authWebService: AuthWebService,
    private vehicleService: VehicleService,private toastService:ToastNotificationService,
    private activeRoute: ActivatedRoute, private placeService: PlaceService,
    private documenttypeService: DocumenttypeService, private timetblSrc: TimetableService,
    private routeService: RouteService, private countryService: CountryService, private datePipe: DatePipe) {
    this.toastr.clear();

  }

  quillConfig={
    //toolbar: '.toolbar',
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        //['code-block'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction

        ['clean'],                                         // remove formatting button

        ['link'],
        ['link', 'image', 'video']
      ],

    }

  }

  ngOnInit() {

    if (environment.authWebApi.systemData != null && environment.authWebApi.systemData.Configurations != null) {
      this.permitStatus13 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus13').Value;
    }

    this.timeTableTemplate = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'TimeTableTemplate').Value;

    this.isDuplicateMode = this.router.url.indexOf('duplicate') > 0;
    if (this.router.url.indexOf('view') > 0) {
      this.isProcess=false;
    }
    if(this.router.url.indexOf('change') > 0){
      if(this.activeRoute.params['_value'].ctrlType!=undefined && this.activeRoute.params['_value'].ctrlType=='vehicle'){
        this.isDuplicateMode=true;
      }
    }

    this.applicationService.getById(this.dataCntrl.application.id).subscribe(app=>{
      this.dataCntrl.application = app;
      this.getTimeTable();
    });

    if(!this.authWebService.userData.Roles[0].IsExternalRole){
      this.isExternalRole = false;
    }

  }
  

  getTimeTable() {
    this.isLoading = true;
    console.log("Timetable", this.dataCntrl.application.timeTableDetail)
    if(this.dataCntrl.application.timeTableDetail == null || this.dataCntrl.application.timeTableDetail == undefined ||  this.dataCntrl.application.timeTableDetail == '' ||  this.dataCntrl.application.timeTableDetail ==="")
    {
      this.timeTableDetail = this.dataCntrl.application.timeTableDetail = this.timeTableTemplate;
    }
    else{
      this.timeTableDetail = this.dataCntrl.application.timeTableDetail;
    }
    this.isLoading = false;

  }
  @Output() previousStep = new EventEmitter<number>();

  goBack() {
    this.previousStep.emit(5);
  }
  @Output() nextStep = new EventEmitter<number>();
  goNextStep() {
    this.nextStep.emit(5);
  }

  async saveTable() {
    this.message="Saving TimeTable, Please wait...";
    this.isLoading = true;
    this.dataCntrl.application.timeTableDetail = this.timeTableDetail;    
    //this.dataCntrl.application.timeTableDetailImg = await this.convertTabletoImage(this.timeTableDetail);
     //alert(JSON.stringify(this.dataCntrl.application.timeTableDetailImg));

    if (this.router.url.indexOf('duplicate') > 0 && this.router.url.indexOf('edit') < 0) {
      //console.log("duplicated");
      //console.log(this.dataCntrl.application);
      this.applicationService.putApplicationDuplicate(this.dataCntrl.application)
        .subscribe((result:any) => {
          this.dataCntrl.application = result;
          // this.saveDepatureDestination();
          this.toastService.success('Application duplicated successfully', 'Duplicate Application');
          let url: any = "carrier/permit/application/duplicate/edit/" + result.id;
          this.router.navigate([url]);
        },
          error => {
            this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')

            // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
            return;
          });
    }
    if (this.router.url.indexOf('correction') > 0) {
      return this.applicationService.setTab(7);
    } else {
      
      
      console.log(this.dataCntrl.application);
      this.applicationService.putApplication(this.dataCntrl.application).subscribe(x=>{
        this.toastService.success('Timetable Saved!', 'Save Application');
        this.isLoading=false;
      });
      if(!this.isApproval)
      {
        this.applicationService.setTab(6);
        document.getElementById('timetable-stepper-next').click();
      }
    }
  }

  replaceWith(theTable) : any
    {  
      console.log(theTable);
      var html = '';  
      
    
      $('tr', theTable).each(function() {  
          html += '<div>';  
          $('th', this).each(function() {  
            html += '<div>' + $(this).html() + '</div>';  
        });  
          $('td', this).each(function() {  
              html += '<div>' + $(this).html() + '</div>';  
          });  
          html += '</div>';  
      });  
      

      html.replace('&nbsp;','');
      return '<div>' + html + '</div>';  
  }   
  cancelApplication() {
    let prevUrl = localStorage.getItem('previousUrl');
    if (prevUrl.search('/permit/approval') != -1) {
      this.router.navigate(['/permit/approval/']);
    } else if (prevUrl.search('/carrier/permit/application/mypermits') != -1) {
      this.router.navigate(['/carrier/permit/application/mypermits/',this.dataCntrl.carrierID]);
    } else {
      this.router.navigate(['/carrier/permit/application/',this.dataCntrl.carrierID]);
    }
  }

   createElementFromHTML(htmlString) : HTMLDivElement {
     
    var div = document.createElement('div');
    div.setAttribute("id", "test");

    div.innerHTML = htmlString.trim();    
    // Change this to div.childNodes to support multiple top-level nodes
    return div; 
  }
 
  async convertTabletoImage(theTable) :Promise<string>
  {
    
      var node = this.createElementFromHTML(theTable);
     
      //console.log(node);
      //alert(JSON.stringify(node));
      let myImageBlob : any; 
      
      //console.log(node);
      var cbe = document.getElementById('test');
      // console.log(cbe);
      // console.log(document.body);
      // console.log($('div#test2').get[0]);
      await this.getScreenshotOfElement($('div#test2').get[0], 0, 0, 100, 100, function(data) {
        // in the data variable there is the base64 image
        // exmaple for displaying the image in an <img>
        myImageBlob = data;
    });

    

 
     console.log(myImageBlob);
      var theImage = myImageBlob;//.src.replace("data&colon;image/png;base64,","");
      return theImage;
     
        
  }

   async getScreenshotOfElement(element, posX, posY, width, height, callback) {
     console.log(element);
     await html2canvas(element,{width: width,
      height: height,
      useCORS: true,}).then(canvas => {
      var imgData = canvas.toDataURL();
     // alert(imgData);
      callback(imgData.replace("data:image/png;base64,", ""));
      
 });
  // await  html2canvas(element, {  
  //     width: width,
  //     height: height     
  //   }).then(canvas =>{
  //     alert(1);
  //     var imgData = canvas.toDataURL("image/png");

  //       var context = canvas.getContext('2d');
  //       var imageData = context.getImageData(posX, posY, width, height).data;
  //       var outputCanvas = document.createElement('canvas');
  //       var outputContext = outputCanvas.getContext('2d');
  //       outputCanvas.width = width;
  //       outputCanvas.height = height;
  //       alert(2);
  //       var idata = outputContext.createImageData(width, height);
  //       idata.data.set(imageData);
  //       outputContext.putImageData(idata, 0, 0);
  //       callback(outputCanvas.toDataURL().replace("data:image/png;base64,", ""));
    
  //   });
}

  
   
  backToTab() {
    this.applicationService.setTab(4);
    document.getElementById('timetable-stepper-prev').click();
  }
}
